export const commissioningModule = {
  state: {
    selectedCommissioning: {},
    files: {},
    fileURLs: {},
  },
  mutations: {
    deleteSelectedCommissioning(state) {
      state.selectedCommissioning = {};
    },
    setSelectedCommissioning(state, selectedCommissioning) {
      state.selectedCommissioning = selectedCommissioning;
    },
    updateSelectedCommissioningData(state, newValue) {
      Object.keys(newValue).forEach((changedPart) => {
        state.selectedCommissioning[changedPart] = newValue[changedPart];
      });
    },
    // updateCommissioningOrderRequest/-Data carry order.payload fields (unit, meter_position, ...),
    // not top-level order fields - keep them separate from updateSelectedCommissioningData
    updateSelectedCommissioningPayloadData(state, newValue) {
      state.selectedCommissioning.payload = {
        ...state.selectedCommissioning.payload,
        ...newValue,
      };
    },
    updateLastChangedByInSelectedCommissioning(state, last_changed_by) {
      state.selectedCommissioning.last_changed_by = last_changed_by;
    },
    updateLastUpdateInSelectedCommissioning(state, last_update) {
      state.selectedCommissioning.last_update = last_update;
    },
    setCommissioningFileHistoryFromBackend(state, file) {
      state.files[file.name] = file;
    },
    setCommissioningFileURL(state, object) {
      state.fileURLs[object.imageName] = object.url;
    },
  },
  getters: {
    getSelectedCommissioning(state) {
      return state.selectedCommissioning;
    },
    getCommissioningFileFromBackend: (state) => (fileName) => {
      return state.files[fileName];
    },
    getCommissioningFileURLByName: (state) => (fileName) => {
      return state.fileURLs[fileName];
    },
  },
  actions: {},
};
